// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/svg/locker.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-group.label-to-the-left {
  display: grid;
  grid-template-columns: auto 250px;
  grid-gap: 17px;
  align-items: center;
}
.select-group.label-to-the-left .select-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--gray_dark1);
}
.select-group .select-label.with-clear {
  display: flex;
  justify-content: space-between;
}
.select-group .select-label.with-clear .select-label-clear-btn {
  cursor: pointer;
  color: var(--color_primary_500);
}
.select-group .select-label {
  font-size: 12px;
  font-weight: 400;
  color: var(--gray_dark2);
}
.select-group .filter {
  margin-left: 0;
}
.select-group .select-icon-group {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--gray_light1);
  border-radius: 4px;
  background: var(--base_color2);
}
.select-group .select-icon-group:focus-within {
  border-color: var(--color_primary_500);
}
.select-group .select-icon-group .filter {
  width: 100%;
}
.select-group .select-icon-group .filter > div {
  border: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  min-width: 220px;
}
.select-group .select-icon-group .select-icon {
  fill: var(--gray_dark1);
}

.reactSelect-sublabel {
  color: var(--gray);
  font-size: 12px;
}
.reactSelect-sublabel.selected {
  color: var(--base_color2);
}

.option-disabled.filter-post {
  cursor: default;
  display: block;
  font-size: inherit;
  padding: 8px 12px;
  width: 100%;
  box-sizing: border-box;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 355px center;
}
.option-disabled.tooltipped-n::after {
  bottom: 17%;
}
.option-disabled.tooltipped-n::before {
  border-top-color: transparent;
}

.select-icon-group {
  transform: translateZ(0);
}
.select-icon-group .container-option .popover-language-content {
  -webkit-user-select: auto;
     -moz-user-select: auto;
          user-select: auto;
  display: none;
}
.select-icon-group .container-option:hover .popover-language-content {
  -webkit-user-select: auto;
     -moz-user-select: auto;
          user-select: auto;
}
.select-icon-group .container-option:hover .popover-language-content .text {
  margin-bottom: 36px;
}
.select-icon-group .container-option:hover .popover-language-content .email {
  -webkit-user-select: auto;
     -moz-user-select: auto;
          user-select: auto;
  font-size: 14px;
  line-height: 20px;
  color: var(--gray_dark2);
  display: block;
}
.select-icon-group .container-option:hover .popover-language-content .image {
  display: block;
  width: 64px;
  height: 64px;
  margin: 10px auto;
}
.select-icon-group .container-option:hover .popover-language-content {
  box-shadow: 8px 10px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid var(--gray_light2);
  border-radius: 4px;
  display: block;
  position: fixed;
  padding: 10px 20px 28px;
  left: 102%;
  top: 104%;
  background: #fff;
  width: 230px;
}`, "",{"version":3,"sources":["webpack://./src/components/ReactSelect/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,iCAAA;EACA,cAAA;EACA,mBAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AAAN;AAKI;EACE,aAAA;EACA,8BAAA;AAHN;AAKM;EACE,eAAA;EACA,+BAAA;AAHR;AAJE;EAWE,eAAA;EACA,gBAAA;EACA,wBAAA;AAJJ;AAOE;EACE,cAAA;AALJ;AAQE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,8BAAA;AANJ;AAQI;EACE,sCAAA;AANN;AASI;EACE,WAAA;AAPN;AASM;EACE,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;AAPR;AAWI;EACE,uBAAA;AATN;;AAcA;EACE,kBAAA;EACA,eAAA;AAXF;AAaE;EACE,yBAAA;AAXJ;;AAgBE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,iCAAA;AAbJ;AAiBI;EACE,WAAA;AAfN;AAkBI;EACE,6BAAA;AAhBN;;AAqBA;EACE,wBAAA;AAlBF;AAqBI;EACE,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,aAAA;AAnBN;AAuBM;EACE,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AArBR;AAuBQ;EACE,mBAAA;AArBV;AAwBQ;EACE,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AAtBV;AAyBQ;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAvBV;AAIM;EAsBE,6CAAA;EACA,oCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAvBR","sourcesContent":[".select-group {\n  &.label-to-the-left {\n    display: grid;\n    grid-template-columns: auto 250px;\n    grid-gap: 17px;\n    align-items: center;\n\n    .select-label {\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--gray_dark1);\n    }\n  }\n\n  .select-label {\n    &.with-clear {\n      display: flex;\n      justify-content: space-between;\n\n      .select-label-clear-btn {\n        cursor: pointer;\n        color: var(--color_primary_500);\n      }\n    }\n\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--gray_dark2);\n  }\n\n  .filter {\n    margin-left: 0;\n  }\n\n  .select-icon-group {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--gray_light1);\n    border-radius: 4px;\n    background: var(--base_color2);\n\n    &:focus-within {\n      border-color: var(--color_primary_500);\n    }\n\n    .filter {\n      width: 100%;\n\n      &>div {\n        border: none;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        min-width: 220px;\n      }\n    }\n\n    .select-icon {\n      fill: var(--gray_dark1);\n    }\n  }\n}\n\n.reactSelect-sublabel {\n  color: var(--gray);\n  font-size: 12px;\n\n  &.selected {\n    color: var(--base_color2);\n  }\n}\n\n.option-disabled {\n  &.filter-post {\n    cursor: default;\n    display: block;\n    font-size: inherit;\n    padding: 8px 12px;\n    width: 100%;\n    box-sizing: border-box;\n    background-image: url(../../assets/images/svg/locker.svg);\n    background-repeat: no-repeat;\n    background-position: 355px center;\n  }\n\n  &.tooltipped-n {\n    &::after {\n      bottom: 17%;\n    }\n\n    &::before {\n      border-top-color: transparent;\n    }\n  }\n}\n\n.select-icon-group {\n  transform: translateZ(0);\n\n  .container-option {\n    .popover-language-content {\n      user-select: auto;\n      display: none;\n    }\n\n    &:hover {\n      .popover-language-content {\n        user-select: auto;\n\n        .text {\n          margin-bottom: 36px;\n        }\n\n        .email {\n          user-select: auto;\n          font-size: 14px;\n          line-height: 20px;\n          color: var(--gray_dark2);\n          display: block;\n        }\n\n        .image {\n          display: block;\n          width: 64px;\n          height: 64px;\n          margin: 10px auto;\n        }\n\n        box-shadow: 8px 10px 12px rgba(0, 0, 0, 0.15);\n        border: 1px solid var(--gray_light2);\n        border-radius: 4px;\n        display: block;\n        position: fixed;\n        padding: 10px 20px 28px;\n        left: 102%;\n        top: 104%;\n        background: #fff;\n        width: 230px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
